import { MouseEvent } from "react";
type Props = {
  href?: string;
  onClick?: (e: MouseEvent<HTMLAnchorElement, globalThis.MouseEvent>) => void;
  label: string;
};
export function Link({ onClick, href, label }: Props) {
  return (
    <a
      className={"underline text-blue-600 cursor-pointer"}
      href={href}
      onClick={onClick}
    >
      {label}
    </a>
  );
}
